export default __webpack_public_path__ + "static/14-0543061df618e4d2f014a9167c621775.jpg";